module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/vue-wechat-jssdk-188.vue");


//////////////////
// WEBPACK FOOTER
// ./en/wechat/vue-wechat-jssdk.md
// module id = 628
// module chunks = 203